import type { ReactNode } from "react"
import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    message: {
        borderRadius: ".5rem",
        padding: ".75rem 1rem",
        fontWeight: "500",
        marginBottom: ".5rem",
    },
    messageInfo: {
        color: theme.palette.tailwind.blue[950],
        background: theme.palette.tailwind.sky[100],
    },
    messageBlocking: {
        color: theme.palette.tailwind.red[950],
        background: theme.palette.tailwind.red[100],
    },
}))

type DeliveryMessageBoxProps = Readonly<{
    // "blocking": no delivery is possible at all, the user has to change something.
    // "info": the order can go through, this only tells the user what to expect.
    isBlocking?: boolean
    children?: ReactNode
}>

export function DeliveryMessageBox({ isBlocking = false, children }: DeliveryMessageBoxProps) {
    const { classes, cx } = useStyles()

    return (
        <Typography
            variant="body2"
            className={cx(classes.message, isBlocking ? classes.messageBlocking : classes.messageInfo)}
        >
            {children}
        </Typography>
    )
}
